export default __webpack_public_path__ + "a602004bff058e339ae3482b503b93f8.png";